
import MultiSelectForm from './MultiSelectForm'

function App() {
  return (
    <div className="App">
      <MultiSelectForm />
    </div>
  );
}

export default App;
